/** Shared harmonious palette for charts & timeline */
export const palette = {
  teal: "#0d9488",
  sky: "#0284c7",
  slate: "#475569",
  amber: "#d97706",
  ink: "#0f172a",
  muted: "#94a3b8",
  grid: "#e2e8f0",
  axis: "#94a3b8",
  legend: "#475569",
  positive: "#059669",
  negative: "#dc2626",
} as const;

export const chartSeries = [
  palette.teal,
  palette.sky,
  palette.slate,
  palette.amber,
] as const;

export const skillColors = [
  "#0d9488",
  "#0284c7",
  "#0f766e",
  "#0369a1",
  "#475569",
  "#d97706",
  "#64748b",
  "#14b8a6",
] as const;
